import { motion } from 'framer-motion';
import { framework, ladder } from '../data/framework';

export default function ShiftFramework() {
  return (
    <section id="framework" className="mx-auto max-w-6xl px-6 py-32">
      <h2 className="font-display text-4xl md:text-6xl tracking-tight2 mb-4">
        SHIFT — a five-rung adoption ladder.
      </h2>
      <p className="text-ink-dim text-lg max-w-2xl mb-12">
        A whiteboardable framework for CxOs who have to brief a board on Monday.
      </p>
      <div className="grid md:grid-cols-5 gap-4 mb-16">
        {framework.map((f, i) => (
          <motion.div
            key={f.letter}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.35, delay: i * 0.06 }}
            className="rounded-2xl border hairline bg-elevated/60 p-6"
          >
            <div className="font-display text-5xl text-accent">{f.letter}</div>
            <div className="font-display text-lg mt-2 mb-2">{f.name}</div>
            <p className="text-sm text-ink-dim leading-relaxed">{f.desc}</p>
          </motion.div>
        ))}
      </div>
      <h3 className="font-display text-2xl tracking-tight2 mb-4">
        The autonomy ladder
      </h3>
      <ol className="space-y-2">
        {ladder.map((rung, i) => (
          <motion.li
            key={rung.name}
            initial={{ opacity: 0, x: -8 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.3, delay: i * 0.04 }}
            className="grid grid-cols-[40px_140px_1fr] items-baseline gap-4 p-4 rounded-lg border hairline bg-bg/40"
          >
            <span className="font-display text-2xl text-accent">{i + 1}</span>
            <span className="font-display">{rung.name}</span>
            <span className="text-ink-dim text-sm">{rung.desc}</span>
          </motion.li>
        ))}
      </ol>
      <p className="mt-8 text-ink-dim italic text-sm">
        Rule of thumb: no workflow should be more than one rung above its
        eval coverage.
      </p>
    </section>
  );
}
